import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWxzJTIwbWVldGluZyUyMHRlYW18ZW58MHx8fHwxNzg2NTU0MTk3fDA&ixlib=rb-4.1.0&q=85";

const chapters = [
  {
    n: "01",
    title: "Eficiencia Operativa",
    body: "Centralizar recursos humanos, legal y contabilidad en un solo proveedor elimina la fricción entre áreas y acelera cada decisión de su empresa.",
  },
  {
    n: "02",
    title: "Reducción de Riesgos",
    body: "Cumplimiento normativo laboral y tributario permanente. Anticipamos conflictos y contingencias legales y financieras antes de que ocurran.",
  },
  {
    n: "03",
    title: "Ahorro Significativo",
    body: "Un paquete integral cuesta considerablemente menos que contratar cada servicio por separado, con la coordinación de un equipo multidisciplinario.",
  },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const Nosotros = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="nosotros" ref={ref} className="relative py-28 sm:py-36 bg-vnavy overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-vteal-light" />
                <span className="text-sm uppercase tracking-[0.3em] text-vteal-light font-semibold">Nosotros</span>
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-white leading-tight">
                Un solo aliado para toda la operación de su empresa
              </h2>
              <p className="mt-6 text-gray-400 leading-relaxed">
                En Grupo Vértice contamos con un equipo multidisciplinario que ofrece un paquete integral de servicios,
                diseñado específicamente para el tamaño y la complejidad operativa de su empresa.
              </p>
            </motion.div>

            <motion.div style={{ y: imgY }} className="mt-10 rounded-2xl overflow-hidden border border-white/10 hidden lg:block">
              <img src={ABOUT_IMG} alt="Equipo profesional en reunión" className="w-full h-72 object-cover" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 lg:pt-6">
            <div className="divide-y divide-white/10 border-t border-white/10">
              {chapters.map((c, i) => (
                <motion.div
                  key={c.n}
                  custom={i}
                  variants={fade}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, margin: "-80px" }}
                  className="grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-10 group"
                >
                  <span className="font-serif text-5xl sm:text-7xl text-white/15 group-hover:text-vteal-light/60 transition-colors duration-500 leading-none">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl sm:text-3xl text-white mb-3">{c.title}</h3>
                    <p className="text-gray-400 leading-relaxed max-w-xl">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
